export { default } from "./BottomNavigation-component";
